import { call, put } from 'redux-saga/effects'
import { http_check_payment, http_generate_iban, http_get_pis_enabled, http_make_payment, http_make_pis } from 'src/http'
import { iban_outcome_t, is_pis_enabled_outcome_t, payment_outcome_t, saga_act, pis_outcome_t } from 'src/types'

import { shoot } from '../actions'
import { saga_do_request } from './base.saga'

/**
 * Generate IBAN
 */
export function* saga_generate_iban(action: saga_act): unknown {
  const outcome: iban_outcome_t = yield call(saga_do_request, http_generate_iban, {
    ...action,
  })
  if (outcome) {
    yield put(shoot.reduce_outcome_iban(outcome))
  }
}

/**
 * Make payment
 */
export function* saga_make_payment(action: saga_act): unknown {
  const outcome: payment_outcome_t = yield call(saga_do_request, http_make_payment, {
    ...action,
  })
  if (outcome) {
    yield put(shoot.reduce_outcome_payment(outcome))
  }
}

/** 
 * Make pis
 */

export function* saga_make_pis(action: saga_act): unknown {
  const outcome: pis_outcome_t = yield call(saga_do_request, http_make_pis, {
    ...action,
  })
  if (outcome) {
    yield put(shoot.reduce_outcome_pis(outcome))
  }
}

/**
 * Check payment
 */
export function* saga_check_payment(action: saga_act): unknown {
  const outcome: payment_outcome_t = yield call(saga_do_request, http_check_payment, {
    ...action,
  })
  if (outcome) {
    yield put(shoot.reduce_outcome_payment_status(outcome))
  }
}

/**
 * Pis enabled
 */
export function* saga_get_pis_enabled(action: saga_act): unknown {
  const outcome: is_pis_enabled_outcome_t = yield call(saga_do_request, http_get_pis_enabled, {
    ...action,
  })
  if (outcome?.isPisEnabled !== undefined) {
    yield put(shoot.reduce_outcome_is_pis_enabled(outcome?.isPisEnabled))
  }
}
